<script setup>
import {defineProps} from "vue";

//==================================================================//
//========================= Props / Emits ==========================//
//==================================================================//

const props = defineProps([
    "dados",
]);

//==================================================================//
//======================== Dados Headers ===========================//
//==================================================================//

let dadosHeaders = [
    { text: "",                              value: "controles"},
    { text: "N°",                            value: "codigo"},
    { text: "Status",                        value: "status"},
    { text: "Credor",                        value: "credorNome"},
    { text: "Valor Original",                value: "valorOriginal"},
    { text: "Valor a Reservar",              value: "valorParaReservar"},
    { text: "Soma dos Descontos",           value: "valorDesconto"},
    { text: "Soma dos Pagamentos",          value: "valorPagamento"},
    { text: "Valor Reservado",               value: "valorReservado"},
    { text: "Valor a Liquidar",              value: "valorParaPagar"},
    { text: "Valor Liquidado",               value: "valorPago"},
    { text: "Valor a Vincular",              value: "valorParaVincular"},
    { text: "Valor Vinculado",               value: "valorVinculado"},
    { text: "Contas a Pagar",                value: "contasAPagarQuantidade"},
    { text: "Pagamentos",                    value: "contasAPagarPagamentosQuantidade"},
    { text: "",                              value: "espaco"},
]

</script>

<template>

    <div class="c-table__header">

        <div class="c-header__cell" v-for="dadoHeader in dadosHeaders"
            :key="dadoHeader.value"
        >

            <div class="c-cell c-cell__text">

                {{dadoHeader.text}}

            </div>
            
        </div>

    </div>

</template>

<style scoped>

/*==================================================================*/
/*============================ Table ===============================*/
/*==================================================================*/

.c-table__header{
    display: grid;
    grid-template-columns: subgrid;
    grid-column: 1 / -1;
    color: rgba(0, 0, 0, 0.6);
    font-size: 0.75rem;
}

.c-header__cell{
    align-content: center;
    padding: 14px 16px;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
    font-weight: 700;
    background-color: #230bc1;
    color: #ffffff;
}

</style>